import React, { useEffect } from 'react';
import Hero from '../components/Hero';
import StatsBar from '../components/StatsBar';
import ServiceCards from '../components/ServiceCards';
import Clients from '../components/Clients';

const Home = () => {
    // Scroll to top on mount
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="flex flex-col">
            <Hero />
            <StatsBar />
            <ServiceCards />
            <Clients />
        </div>
    );
};

export default Home;
